import validator from 'validator';

export function normalizeUrl(str: string): string | null {
    // Trim whitespace first
    const trimmed = str.trim();
    if (!trimmed) {
        return null;
    }

    // Add protocol if missing so URL() can parse it
    let normalized = trimmed;
    if (!/^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(trimmed)) {
        normalized = 'https://' + trimmed;
    }

    // Validate with validator.js
    if (!validator.isURL(normalized, { require_protocol: true })) {
        return null; // invalid
    }

    // Parse and normalize using URL constructor (handles trailing slashes, encoding, etc.)
    try {
        const url = new URL(normalized);
        return url.toString();
    } catch (error) {
        return null; // URL() threw, invalid format
    }
}
